import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["click", "mousemove", "keydown", "touchstart"];

export default function useIdleLogout({ enabled, timeoutMinutes, onIdle, paused }) {
    const timeoutRef = useRef(null);
    const onIdleRef = useRef(onIdle);
    const pausedRef = useRef(paused);

    onIdleRef.current = onIdle;
    pausedRef.current = paused;

    useEffect(() => {
        if (!enabled || !timeoutMinutes) return;

        const resetTimer = () => {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                if (pausedRef.current) resetTimer();
                else onIdleRef.current();
            }, timeoutMinutes * 60 * 1000);
        };

        ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, resetTimer));
        resetTimer();

        return () => {
            clearTimeout(timeoutRef.current);
            ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, [enabled, timeoutMinutes]);
}
